import { Flex, Form, FormInstance, TableColumnsType } from 'antd';
import * as Component from 'components';
import {
  TransferDataHandlerInterface,
  TransferDataSourceInterface,
} from 'components/transfer/Transfer';
import { seasonService } from 'content/service';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { SeasonInterface } from 'type/seasonType';
import { playlistRuleService } from '../services/playlistRuleService';

export const SeasonRule: React.FC<{
  form: FormInstance;
}> = ({ form }) => {
  const { id } = useParams<{ id: string }>();
  const [] = useState(0);

  const columns: TableColumnsType<TransferDataSourceInterface> = [
    {
      dataIndex: 'id',
      title: 'Id',
      width: '10%',
    },
    {
      dataIndex: 'name',
      title: 'Name',
      render: (_, record): React.ReactNode => {
        return (
          <Flex align="center" gap="small">
            <span>{record.name}</span>
          </Flex>
        );
      },
    },
  ];

  const filterOption = (input: string, item: SeasonInterface): boolean =>
    item.title?.includes(input);

  const mapToTransferItem = (season: SeasonInterface): TransferDataSourceInterface => ({
    ...season,
    key: season.id,
    name: season.title,
    disabled: false,
    poster: undefined,
  });

  const dataHandler: TransferDataHandlerInterface = {
    fetchSourceData: async (query: Record<string, string>) => {
      const seasons = await seasonService.fetch(new URLSearchParams(query));
      return {
        data: seasons.results.map(mapToTransferItem),
        count: seasons.count,
      };
    },
    fetchTargetData: async (query: Record<string, string>) => {
      const filteredQuery = Object.fromEntries(Object.entries(query).filter(([_, value]) => value));

      const { results: seasons, count } = await playlistRuleService.fetchSeasonRules(
        form,
        Number(id),
        new URLSearchParams(filteredQuery)
      );
      return {
        data: seasons.map(mapToTransferItem),
        count,
      };
    },
    createWithParentId: async (ids: number[]) => {
      const seasonIds = form.getFieldValue('season');
      if (!seasonIds) {
        form.setFieldValue('season', ids);
      } else {
        const deduplicatedIds = [...new Set([...seasonIds, ...ids])];
        form.setFieldValue('season', deduplicatedIds);
      }
    },
    deleteWithParentId: async (ids: number[]) => {
      const seasonIds = form.getFieldValue('season');
      if (!seasonIds) {
        form.setFieldValue('season', []);
      } else {
        const deduplicatedIds = seasonIds.filter((id: number) => !ids.includes(id));
        form.setFieldValue('season', deduplicatedIds);
      }
    },
  };

  return (
    <div>
      <h3 style={{ display: 'flex', alignItems: 'center' }}>
        <span>Season</span>
        <span
          style={{
            flex: 1,
            borderBottom: '1px solid #666',
            marginLeft: '8px',
            height: '0.5em',
          }}
        />
      </h3>
      <Form.Item name="season" noStyle>
        <Component.TransferComponent
          dataHandler={dataHandler}
          filterOption={filterOption}
          columns={columns}
        />
      </Form.Item>
    </div>
  );
};
